module.exports = __webpack_public_path__ + "assets/icons/ic_insert_drive_file-09cc.svg";